import { useEffect } from 'react';

const useResourcePreloader = () => {
  useEffect(() => {
    // Preload critical images when the component mounts
    const criticalImages = [
      require('../assets/optimized/pfp.webp'),
      require('../assets/optimized/vortexio.webp'),
      require('../assets/optimized/DECGamingStudioLogo.webp'),
    ];

    criticalImages.forEach(src => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });

    // Cleanup function
    return () => {
      // Remove preload links when component unmounts
      criticalImages.forEach(src => {
        const link = document.querySelector(`link[href="${src}"]`);
        if (link) {
          document.head.removeChild(link);
        }
      });
    };
  }, []);
};

export default useResourcePreloader;